// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"d278d1d3","683":"30b39fea","863":"29b0c83a","954":"8b17feb6"}[chunkId] + ".chunk.css";
};